import React from 'react';
import IconAiSparkles from './IconAiSparkles';
import { getLookupSuggestions } from './services/apiService';
import {
  createSemanticSearchContext,
  performSemanticSearch,
} from './SemanticSearch';

const LOOKUP_SUGGESTION_ORDER = ['genre', 'subgenre', 'thematic'];

export function createLookupSearchContext(value, suggestion = '') {
  const query = value.trim();
  const normalizedSuggestion = suggestion.trim();

  return {
    query,
    expandedQuery: normalizedSuggestion ? `${query} ${normalizedSuggestion}`.trim() : '',
  };
}

export async function performLookupSearch(
  config,
  requestConfig,
  keywordWeight,
  fromPos,
  searchContext
) {
  if (searchContext?.expandedQuery) {
    return performSemanticSearch(
      config,
      requestConfig,
      keywordWeight,
      fromPos,
      createSemanticSearchContext(searchContext.expandedQuery, true),
      {}
    );
  }

  const query = searchContext?.query || '';
  const [lookupData, semanticResult] = await Promise.all([
    getLookupSuggestions(config, query),
    performSemanticSearch(
      config,
      requestConfig,
      keywordWeight,
      fromPos,
      createSemanticSearchContext(query, true),
      {}
    ),
  ]);

  return {
    ...semanticResult,
    suggestions: lookupData || [],
    lookupQuery: query,
  };
}

export default function LookUpSuggestions({
  suggestions,
  isMainSearchLoading,
  onSuggestionClick,
}) {
  const showSuggestions = !isMainSearchLoading && suggestions.length > 0;

  if (!showSuggestions) {
    return null;
  }

  return (
    <div className="suggestion-container">
      <div className="suggestion-btn-row">
        {suggestions.map((suggestion, index) => (
          <button
            key={`lookup-suggestion-${index}`}
            className="suggestion-btn suggestion-btn-suggestion"
            onClick={() => onSuggestionClick(suggestion)}
          >
            <span className="suggestion-btn-icon"><IconAiSparkles size={20} /></span>
            <span className="suggestion-btn-label">{suggestion}</span>
          </button>
        ))}
      </div>
    </div>
  );
}